import { autorun } from "mobx";
import { markStore } from "@lib/store/src/mark";
import { getMarkModalTemplate } from "./mark-modal.templates";

export class MarkModal {
  private container: HTMLElement;

  constructor(containerId: string) {
    const existing = document.getElementById(containerId);
    if (existing) {
      this.container = existing;
    } else {
      this.container = document.createElement("div");
      this.container.id = containerId;
      document.body.appendChild(this.container);
    }
    this.render();
  }

  private render() {
    const { isOpen, marks } = markStore;
    this.container.innerHTML = "";
    if (!isOpen || !marks.length) return;
    const modal = getMarkModalTemplate();
    this.container.appendChild(modal);
    const closeBtn = modal.querySelector(".close-btn");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        markStore.closeModal();
      });
    }
  }

  initObserver() {
    return autorun(() => {
      this.render();
    });
  }
}